import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Collapse from '@material-ui/core/Collapse'
import Typography from '@material-ui/core/Typography'
import LineChart from './LineChart'
import getFeaturesFromGeoJson from '../utility/getFeaturesFromGeoJson'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetSelectedData } from '../selectors/selectedDataSelector'
import { makeGetData } from '../selectors/dataSelector'
import ObjectActions from '../redux/objectRedux'
import MapActions from '../redux/mapRedux'
import TimeSliderActions from '../redux/timeSliderRedux'
import { RED, YELLOW, GREEN } from '../config/colors'

const chartStyles = {
  scatter: {
    data: {
      strokeWidth: 3,
      stroke: 'gray',
      strokeOpacity: 0.4,
      fill: d => (d.ratio < 0.95 ? RED : d.ratio < 1.05 ? YELLOW : GREEN)
    }
  }
}

class MopraWellsitesLineChartContainer extends PureComponent {
  handleMouseEnter = (event, data) => {
    const { actions } = this.props
    const uuids = data.data.map(datum => datum.uuid)
    actions.uuidsHighlighted(uuids)
  }

  handleMouseLeave = (event, data) => {
    const { actions } = this.props
    actions.uuidsHighlighted([])
  }

  handleZoomToObject = (event, data) => {
    const { actions } = this.props
    const { latitude, longitude, timestamp } = data.datum
    const center = [longitude, latitude]
    const zoom = [15]
    actions.centerZoomDatetimeChanged(center, zoom, timestamp)
  }

  render () {
    return null
    const { datetime, uuidsSelected, uuidsHighlighted, data } = this.props
    if (!data || data.constructor !== Array) {
      return null
    }

    const wellNames = uuidsSelected
      .map(uuid => {
        const well = data.find(datum => datum.uuid === uuid)
        const wellName = well ? well.well_name : null
        return wellName
      })
      .filter(wellName => wellName)
    const groupByFilters = wellNames.map(wellName => item =>
      item.well_name === wellName
    )

    return (
      <Collapse component='div' in={!!wellNames.length} unmountOnExit>
        <Typography>Wellsite health</Typography>
        <LineChart
          data={data}
          x={value => new Date(value.timestamp)}
          y={value => value.ratio}
          chartStyles={chartStyles}
          groupByFilters={groupByFilters}
          verticalLineAcessor={() => new Date(datetime).getTime()}
          datetime={new Date(datetime).getTime()}
          uuidsHighlighted={uuidsHighlighted}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          handleZoomToObject={this.handleZoomToObject}
        />
      </Collapse>
    )
  }
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()
  const getSelectedData = makeGetSelectedData()
  const getData = makeGetData()

  const mapStateToProps = state => {
    return {
      data: getData(
        state,
        'Mopra',
        getFeaturesFromGeoJson,
        row => new Date(row.timestamp).getMonth() !== 0
      ),
      datetime: getDatetime(state, 'Mopra'),
      selectedData: getSelectedData(state, 'MopraWellsites-fill'),
      uuidsSelected: state.object.uuidsSelected,
      uuidsHighlighted: state.object.uuidsHighlighted
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      centerZoomDatetimeChanged: (center, zoom, datetime) => {
        dispatch(MapActions.centerZoomChanged(center, zoom))
        dispatch(TimeSliderActions.timeSliderValueUpdated(datetime))
      },
      uuidsHighlighted: uuids => dispatch(ObjectActions.uuidsHighlighted(uuids))
    }
  }
}

export default connect(makeMapStateToProps, mapDispatchToProps)(
  MopraWellsitesLineChartContainer
)



// WEBPACK FOOTER //
// ./src/charts/MopraWellsitesLineChartContainer.js